export const products = [
    /*{ id: "p1", name: 'Yum Boujee Marshmallow',
        brand: 'Kayali', stock: false, ss:true,
        image: 'https://www.sephora.com/productimages/sku/s2804821-av-1-zoom-1.jpg?imwidth=1224 ',
        category: 'Eau de Parfum Intense', family: 'Gourmand',
        notes: {
            top: ["Lavanda", "Pera", "Bergamota"],
            heart: ["Crema batida", "Coco"],
            base: ["Praliné", "Vainilla", "Almizcle"]
        },
        Keynotes:'Strawberry, Pink Marshmallow, Whipped Vanilla', gender: 'Dama',
        tam: [
            { ml: 30, price: 850 , oldPrice: 100, stock: true},
            { ml: 50, price: 1150 , oldPrice: 60 },
            { ml: 100, price: 1550 , oldPrice: 880 }
        ],
    },*/
    { id: "p2", name: 'Pure Seduction ',
        brand: 'Victoria´s Secrets', stock: true, ss:false,
        image: 'https://sp.victoriassecret.com/p/1520x2026/png/zz/25/02/06/02/112592031340_OM_F.jpg ',
        category: 'Body Mist', family: 'Floral',
        notes: {
            top: ["Lavanda", "Pera", "Bergamota"],
            heart: ["Crema batida", "Coco"],
            base: ["Praliné", "Vainilla", "Almizcle"]
        },
        Keynotes:'Strawberry, Pink Marshmallow, Whipped Vanilla', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p3", name: 'Mini Cherry Chocolate',
        brand: 'Gisou', stock: false, ss:true,
        image: 'https://www.sephora.com/productimages/sku/s3022381-av-2-zoom.jpg?imwidth=1224',
        category: 'Hair Perfume', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Miel de Mirsalehi,Coco cremoso,Chocolate,Sandalo ',gender: 'Dama',
        tam: [
            { ml: 15, price: 760 , oldPrice: 640 },
        ],
    },
    { id: "p4", name: 'Wild Rose',
        brand: 'Gisou', stock: false, ss:true,
        image: 'https://www.sephora.com/productimages/sku/s2806743-av-01-zoom.jpg?imwidth=1224',
        category: 'Hair Perfume', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Rosa silvestre,Vainilla , Miel de Mirsalehi ',gender: 'Dama',
        tam: [
            { ml: 15, price: 760 , oldPrice: 640 },
            { ml: 50, price: 1180 , oldPrice: 1000 },
        ],
    },
    { id: "p5", name: 'Lavender Berry',
        brand: 'Gisou', stock: false, ss:true,
        image: 'https://www.sephora.com/productimages/sku/s2818623-av-01-zoom.jpg?imwidth=1224',
        category: 'Hair Perfume', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Lavanda,Moras,Miel  ', gender: 'Dama',
        tam: [
            { ml: 15, price: 760 , oldPrice: 640 },
            { ml: 50, price: 1180 , oldPrice: 1000 },
        ],
    },
    { id: "p6", name: 'Vanilla Glaze',
        brand: 'Gisou', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s3015567-av-2-zoom.jpg?imwidth=1224',
        category: 'Hair Perfume', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Vanilla cremosa, Leche ,Almizcle ', gender: 'Dama',
        tam: [
            { ml: 15, price: 760 , oldPrice: 640 },
            { ml: 50, price: 1180 , oldPrice: 1000 },
        ],
    },
    { id: "p7", name: 'Glazed Cherry Body Mist',
        brand: 'Gisou', stock: false, ss:true,
        image: ' https://www.sephora.com/productimages/sku/s2999936-av-2202605121716569220700-zoom.jpg?imwidth=1224',
        category: 'Hair & Body Mist', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Cereza, Frambuesa , Caramelo ', gender: 'Dama',
        tam: [
            { ml: 100, price: 880 , oldPrice: 750 },
        ],
    },
    { id: "p8", name: 'Cheirosa 62',
        brand: 'Sol de Janeiro', stock: false,
        image: 'https://www.sephora.com/productimages/sku/s1930759-av-1-zoom.jpg?imwidth=1224',
        category: 'Perfume Mist', family: 'Cálido y picante', ss:true,
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Pistachio, Caramelo Salteado, Vainilla', gender: 'Dama',
        tam: [
            { ml: 90, price: 690 , oldPrice: 650 },
            { ml: 240, price: 980 , oldPrice: 920 },
        ],
    },
    { id: "p9", name: 'Cheirosa 68 ',
        brand: 'Sol de Janeiro', stock: false, ss:true,
        image: 'https://www.sephora.com/productimages/sku/s2577443-av-1-zoom.jpg?imwidth=1224',
        category: 'Perfume Mist', family: 'Floral',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Jazmín brasileño,Pitahaya,Vainilla', gender: 'Dama',
        tam: [
            { ml: 90, price: 690 , oldPrice: 650 },
            { ml: 240, price: 980 , oldPrice: 920 },
        ],
    },
    { id: "p10", name: 'Cheirosa 59',
        brand: 'Sol de Janeiro', stock: false, ss:true,
        image: 'https://www.sephora.com/productimages/sku/s2734093-av-1-zoom.jpg?imwidth=1224',
        category: 'Perfume Mist', family: 'Cálido y picante',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Violeta, Orquídea vainilla, Sándalo', gender: 'Dama',
        tam: [
            { ml: 90, price: 690 , oldPrice: 650 },
            { ml: 240, price: 980 , oldPrice: 920 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: 'Cheirosa 48',
        brand: 'Sol de Janeiro', stock: false, ss:true,
        image: 'https://www.sephora.com/productimages/sku/s2829992-av-1-zoom-1.jpg?imwidth=1224',
        category: 'Fragance Mist', family: 'Floral',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Guayaba,Orquídea,Almizcle rosa', gender: 'Dama',
        tam: [
            { ml: 90, price: 690 , oldPrice: 650 },
            { ml: 240, price: 980 , oldPrice: 920 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: 'Cheirosa 40',
        brand: 'Sol de Janeiro', stock: false, ss:true,
        image: 'https://www.sephora.com/productimages/sku/s2461812-av-1-zoom.jpg?imwidth=1224',
        category: 'Fragance Mist', family: 'Floral',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Ciruela ámbar negra, Vainilla, Jazmín', gender: 'Dama',
        tam: [
            { ml: 90, price: 690 , oldPrice: 650 },
            { ml: 240, price: 980 , oldPrice: 920 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: 'Cheirosa 76',
        brand: 'Sol de Janeiro', stock: false, ss:true,
        image: ' https://www.sephora.com/productimages/sku/s2796597-av-1-zoom.jpg?imwidth=1224',
        category: 'Fragance Mist', family: 'Flores',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:'Grosella,Jazmín, Ámbar', gender: 'Dama',
        tam: [
            { ml: 90, price: 690 , oldPrice: 650 },
            { ml: 240, price: 980 , oldPrice: 920 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
    { id: "p", name: ' ',
        brand: '', stock: false,
        image: ' ',
        category: '', family: '',
        notes: {
            top: ["", "", ""],
            heart: [" ", ""],
            base: ["", "", ""]
        },
        Keynotes:',  ,  ', gender: 'Dama',
        tam: [
            { ml: 30, price: 380 , oldPrice: 0 },
        ],
    },
]